import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';
import { useNftx } from '@nftx/react';
import { CreateLiquidityPositionQuoteParams } from 'nftx.js';
import { useSlippagePercentage } from '@/presentation/context/settings';

const useCreateLiquidityPositionQuote = ({
  tokenIds,
  liquidity: {
    ethToPair,
    lowerPrice,
    nftsToPair,
    upperPrice,
    vTokenToPair,
    fullRange,
    currentPrice,
  },
  poolId,
  vaultId,
  userAddress,
}: Omit<CreateLiquidityPositionQuoteParams, 'slippagePercentage'>) => {
  const {
    network,
    core: { quoteCreateLiquidityPosition },
  } = useNftx();
  const slippagePercentage = useSlippagePercentage();

  return useQuery(
    [
      QueryKey.CREATE_LIQUIDITY_POSITION_QUOTE,
      network,
      tokenIds,
      ethToPair,
      lowerPrice,
      nftsToPair,
      upperPrice,
      vTokenToPair,
      poolId,
      vaultId,
      slippagePercentage,
      userAddress,
      currentPrice,
    ],
    () => {
      return quoteCreateLiquidityPosition({
        userAddress,
        liquidity: {
          ethToPair,
          lowerPrice,
          nftsToPair,
          upperPrice,
          vTokenToPair,
          fullRange,
          currentPrice,
        },
        tokenIds,
        network,
        slippagePercentage,
        poolId,
        vaultId,
        usePermit2: true,
      });
    },
    { staleTime: 0, cacheTime: 0, refetchInterval: 10000 }
  );
};

export default useCreateLiquidityPositionQuote;
